<template>
  <div class="lookforPwd-wrap">
    <div class="p1">找回密码</div>
    <div class="p2">通过手机验证码找回密码</div>
    <van-form @submit="onSubmit4">
      <van-field
        label="输入新密码"
        v-model="pwd1"
        class="phone"
        type="password"
        placeholder="6-20位字母数字组合"
        ref="tel"
        name="pwd1"
      />
      <div class="code-box">
        <van-field
          label="再次确认"
          v-model="pwd2"
          class="code-input"
          type="password"
          placeholder="6-20位字母数字组合"
          name="pwd2"
        />
      </div>
      <van-button
        class="make_bind"
        native-type="submit"
        :class="{ active: pwd1 != '' && pwd2 != '' }"
        >完成修改</van-button
      >
    </van-form>
  </div>
</template>
<script>
import axios from '../../http';
import md from '../../common/js/md5';
import { mapMutations } from 'vuex';
export default {
  name: 'make_pwd',
  components: {},
  props: {},
  data() {
    return {
      pwd1: '',
      pwd2: '',
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(['getUserAvatar', 'getUserName', 'getUserPhone', 'getToken', 'setUserType']),
    onSubmit4(values) {
      //提交按钮

      let pwd1 = values.pwd1;
      let pwd2 = values.pwd2;
      var reg = /^[^\d]*$|^[^a-zA-Z]*$|[^\da-zA-Z]/;
      if (pwd1 == '') {
        this.$toast('请输入密码');
        return;
      }
      if (pwd1.length > 20 || pwd1.length < 6 || reg.test(pwd1)) {
        this.$toast('6-20位字母数字组合');
        return;
      }
      if (pwd2 == '') {
        this.$toast('请确认密码');
        return;
      }
      if (pwd2 != pwd1) {
        this.$toast('确密码与输入密码不一致');
        return;
      }
      let that = this;
      axios
        .fetchPost('/member/login/forget_pass', {
          mobile: this.$route.query.mobile,
          code: this.$route.query.code,
          password: md(this.pwd1),
          business_type: 'h5',
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);
          if (data.code == 200) {
            setTimeout(() => {
              this.$router.push({
                path: '/secondBar/medication',
              });
              this.getUserAvatar(res.data.data.avatar);
              this.getUserName(res.data.data.nickname);
              this.getUserPhone(res.data.data.mobile);
              this.getToken(res.data.data.token);
              this.setUserType(res.data.data.user_type);
            }, 500);
          } else if (res.data.code == 211) {
            that.$router.push({
              path: '/identity',
              query: { token: res.data.data.token },
            });
          } else {
            setTimeout(() => {
              this.$router.go(-1);
            }, 500);
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.lookforPwd-wrap
  width 100%
  height 100%
  background linear-gradient(-30deg, rgba(79, 194, 101, 1), rgba(0, 164, 103, 1), rgba(18, 154, 140, 1))
  padding-top 75px
  ::-webkit-input-placeholder
    color rgba(255, 255, 255, 0.5)
  ::-moz-placeholder
    color rgba(255, 255, 255, 0.5)
  ::-ms-input-placeholder
    color rgba(255, 255, 255, 0.5)
  .p1
    margin-bottom 30px
    font-size 25px
    font-family Microsoft YaHei
    font-weight 400
    color #fff
  .p2
    font-size 17px
    color #fff
    margin-bottom 40px
  .phone
    width 85%
    margin 0 auto 10px
    border-radius 20px
    color #fff
    background none
    font-size 16px
    outline none
    /deep/.van-field__control
      color #fff
  .code-box
    width 85%
    margin 0 auto
    display flex
    background none
    /deep/.van-field__control
      color #fff
    .code-input
      flex 1
      border-radius 20px
      border-right none
      border-top-right-radius 0
      border-bottom-right-radius 0
      font-size 16px
      outline none
      background none
      color #fff
  .make_bind
    width 85%
    background rgba(255, 255, 255, 0.7)
    border-radius 40px
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    height 40px
    line-height 40px
    margin 55px auto 20px
    border none
    color #282828
    &.active
      color #fff
      background #FF9922
  /deep/.van-field__label
    text-align left
    line-height 40px
  /deep/.van-field__body
    border 1px solid rgba(255, 255, 255, 0.5)
    border-radius 40px
    height 40px
    line-height 40px
    & > input
      text-indent 1em
  .van-cell:not(:last-child)::after
    display none
</style>
